<template>
<div class="question">
  <div class="body">
    <div class="body-content">
      <div>{{question.body}}</div>
    </div>
    <div class="body-option">
      <date-picker ref="DatePicker" v-model="date" :first-day-of-week="1" lang="zh" @change="answer"></date-picker>
    </div>
  </div>
</div>
</template>

<script>
import DatePicker from 'vue2-datepicker'

export default {
  name: 'DateQuestion',
  components: { DatePicker },
  props: ['question'],
  data () {
    return {
      date: null
    }
  },
  methods: {
      answer: function () {
        if (this.date === null) {
          this.$emit('answer', this.question.id, null)
          return
        }
        this.$emit('answer', this.question.id, this.$refs.DatePicker.formatDate(this.date, 'yyyy-MM-dd'))
      },
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/template/question/DateQuestion.vue